export default __webpack_public_path__ + "static/media/Mobile.8fff3064.webp";